import React from 'react';
import { ColProps, Row } from '@visalex/core';

import cx from 'clsx';

import Benefits, { BenefitProps } from '../../Benefits/Benefits';

import commonStyles from '../Technology.module.scss';
import styles from './Features.module.scss';

const prefix = 'technology';

export type FeaturesProps = {
  title: string;
  subtitle: string;
  benefits: BenefitProps[];
  colProps?: ColProps;
};

const Features = ({ title, subtitle, benefits, colProps = { xs: 12, md: 6, xl: 6 } }: FeaturesProps) => {
  return (
    <Row className={styles[`${prefix}__features`]}>
      <h3 className={cx(commonStyles[`${prefix}__title`], styles[`${prefix}__features_title`])}>{title}</h3>
      <p className={cx(commonStyles[`${prefix}__subtitle`], styles[`${prefix}__features_subtitle`])}>{subtitle}</p>
      <Benefits benefits={benefits} colProps={colProps} />
    </Row>
  );
};

export default Features;
